import { gql } from 'apollo-angular';

export const Fragments = gql`
  fragment TenantDetails on Tenant {
    id
    name
    email
    phone
    createdAt
    updatedAt
  }

  fragment LeaseDetails on Lease {
    id
    createdAt
    updatedAt
    startDate
    endDate
  }

  fragment LeaseDetailsWithRelations on Lease {
    ...LeaseDetails
    propertyUnit {
      ...PropertyUnitDetails
      property {
        ...PropertyDetails
      }
    }
    tenants {
      ...TenantDetails
    }
  }

  fragment BaseTaskDetails on BaseTask {
    id
    title
    description
    categories
    details
    resources
    status
    createdAt
    dueAt
    updatedAt
    completedAt
    assignee
  }

  fragment TaskDetails on Task {
    id
    title
    description
    categories
    details
    resources
    status
    evidence {
      id
      url
      description
      submitterId
    }
    createdAt
    dueAt
    updatedAt
    completedAt
    assignee
  }

  fragment TaskDetailsWithRelations on Task {
    ...TaskDetails
    lease {
      ...LeaseDetailsWithRelations
    }
    createdBy {
      id
      name
      email
    }
    createdByTaskSchedule {
      ...TaskScheduleDetails
    }
  }

  fragment TaskScheduleDetails on TaskSchedule {
    id
    title
    enabled
    rrule
    description
    categories
    details
    resources
    createdAt
    updatedAt
    dueIn
    assignee
  }

  fragment TaskScheduleDetailsWithRelations on TaskSchedule {
    ...TaskScheduleDetails
    tasks {
      ...BaseTaskDetails
      lease {
        ...LeaseDetailsWithRelations
      }
    }
    units {
      ...PropertyUnitDetailsWithRelations
    }
  }

  fragment PropertyDetails on Property {
    id
    address
    createdAt
    updatedAt
  }

  fragment PropertyDetailsWithRelations on Property {
    ...PropertyDetails
    organization {
      id
      name
    }
    units {
      ...PropertyUnitDetails
      leases {
        ...LeaseDetails
        tenants {
          ...TenantDetails
        }
      }
    }
  }

  fragment PropertyUnitDetails on PropertyUnit {
    id
    name
    active
    createdAt
    updatedAt
  }

  fragment PropertyUnitDetailsWithRelations on PropertyUnit {
    ...PropertyUnitDetails
    property {
      ...PropertyDetails
    }
    leases {
      ...LeaseDetails
      tenants {
        ...TenantDetails
      }
    }
  }

  fragment ArticleDetails on Article {
    title
    slug
    publishedAt
    hero {
      richText
      media {
        url
        alt
      }
    }
    categories {
      title
    }
    meta {
      title
      description
      image {
        alt
        url
      }
    }
  }

  fragment AnnouncementDetails on Announcement {
    id
    title
    summary
    details
    createdAt
    updatedAt
    publishAt
    status
    units {
      id
      name
    }
  }

  fragment MessageLogDetails on MessageLog {
    id
    channel
    direction
    status
    recipientAddress
    recipientAddresses
    senderAddress
    subject
    body
    templateName
    externalId
    errorMessage
    organizationId
    recipientType
    recipientId
    recipientName
    conversationId
    sourceType
    sourceEntityId
    failureType
    resentFromId
    createdAt
  }
`;
